import StyledHeader from "./navbar-styles";
import { Link } from "react-router-dom";
import { Container } from "react-bootstrap";

const Navbar = () => {
  //lkasdfjlksdf

  return (
    <StyledHeader>
      <Container>
        <Link
          to={{
            pathname: "/",
          }}
        >
          <div className="logo">
            <span>Medistak</span>
          </div>
        </Link>
        <Link
          to={{
            pathname: "/",
          }}
        >
          <button className="styled-button">Sign In</button>
        </Link>
      </Container>
    </StyledHeader>
  );
};

export default Navbar;
